<template>
  <v-container fluid>
    <v-row justify="center" class="mt-n8 mx-1 mb-4">
      <v-icon class="mx-2" size="35px">receipt_long</v-icon>
      <span style="font-size: 34px; color: #616161">Ventas por productos</span>
    </v-row>
    <v-row justify="center">
      <HeaderFilters
        @refreshWarehouse="changeBusiness($event)"
        :show_date_start="true"
        :show_all_option="true"
      />
    </v-row>
    <v-row align="center" justify="center" class="pt-2 pb-3 px-2">
      <v-col cols="12" md="3" class="py-1">
        <v-autocomplete
          v-model="invoice_type"
          outlined
          dense
          @change="getData(lastFilters)"
          hide-details
          :items="[
            { value: 0, text: 'Todo' },
            { value: 2, text: 'Venta directa' },
            { value: 5, text: 'Vouchers / credito empleado' },
            { value: 8, text: 'Bonos' },
          ]"
          label="Tipo de factura"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="3" class="py-1">
        <v-autocomplete
          v-model="invoice_category"
          outlined
          dense
          @change="getData(lastFilters)"
          hide-details
          :items="item_categories"
          label="Categoria de factura"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="3" class="py-1">
        <v-autocomplete
          v-model="currency_filter"
          outlined
          dense
          @change="getData(lastFilters)"
          hide-details
          :items="currencies"
          label="Moneda"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="3" class="py-1">
        <v-autocomplete
          v-model="item_category_filter"
          outlined
          dense
          @change="getData(lastFilters)"
          hide-details
          :items="categories"
          label="Categoria de articulo"
          item-text="name"
          item-value="id"
        ></v-autocomplete>
      </v-col>
    </v-row>

    <v-card class="rounded-lg mt-1">
      <v-tabs v-model="activeTab" background-color="transparent" color="primary" @change="onTabChange">
        <v-tab>
          <v-icon left small>mdi-chart-bar</v-icon>
          Resumen por artículo
        </v-tab>
        <v-tab>
          <v-icon left small>mdi-currency-usd</v-icon>
          Costos detallados
        </v-tab>
      </v-tabs>
      <v-divider></v-divider>

      <v-tabs-items v-model="activeTab">
        <!-- TAB 1: Resumen agrupado por artículo -->
        <v-tab-item>
          <v-expand-transition>
            <v-row v-if="loading" justify="center">
              <v-col cols="12" md="10">
                <v-skeleton-loader
                  type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-data-table
              v-else
              height="50vh"
              :search="search"
              :headers="headers"
              :items-per-page="50"
              :items="items"
              class="elevation-0"
              dense
              fixed-header
              hide-default-footer
              @page-count="pageCount = $event"
              :page.sync="page"
            >
              <template v-slot:top>
                <v-toolbar class="elevation-0 rounded-lg">
                  <v-spacer></v-spacer>
                  <v-col md="4">
                    <v-text-field
                      label="Buscar..."
                      class="mt-0"
                      v-model="search"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-menu bottom origin="center center" transition="scale-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="mr-2 mt-n2" color="success" dark outlined v-bind="attrs" v-on="on">
                        <v-icon class="ml-2">mdi-download</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="save_csv()">
                        <v-list-item-icon>
                          <v-icon color="success">mdi-file-excel-box</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Detallado excel</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-toolbar>
              </template>
              <template v-slot:no-data>
                <v-row justify="center" class="pt-10">
                  <v-icon size="80px">token</v-icon>
                </v-row>
                <v-row justify="center" class="pb-6">No hay datos</v-row>
              </template>
              <template slot="footer">
                <v-row justify="center">
                  <v-container style="width: 70%" class="mt-4">
                    <v-pagination v-model="page" :length="pageCount"></v-pagination>
                  </v-container>
                </v-row>
              </template>
            </v-data-table>
          </v-expand-transition>
          <v-divider></v-divider>
          <v-row justify="end" align="center" class="pa-2">
            <v-col md="4" class="text-right">
              <span style="font-size: 15px" class="font-weight-bold success--text">
                PRECIO COMPRA:
                {{ currency_filter == 0 ? "USD" : currencies.find((e) => e.value == currency_filter).text }}
                {{ currencyFormat(totalValues.cost) }}
              </span>
            </v-col>
            <v-col md="4" class="text-center">
              <span style="font-size: 15px" class="font-weight-bold success--text">
                PRECIO VENTA:
                {{ currency_filter == 0 ? "USD" : currencies.find((e) => e.value == currency_filter).text }}
                {{ currencyFormat(totalValues.neto) }}
              </span>
            </v-col>
          </v-row>
        </v-tab-item>

        <!-- TAB 2: Costos detallados por línea de factura -->
        <v-tab-item>
          <v-expand-transition>
            <v-row v-if="loadingCost" justify="center">
              <v-col cols="12" md="10">
                <v-skeleton-loader
                  type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-data-table
              v-else
              height="50vh"
              :search="searchCost"
              :headers="costHeaders"
              :items-per-page="50"
              :items="costItems"
              class="elevation-0"
              dense
              fixed-header
              hide-default-footer
              @page-count="costPageCount = $event"
              :page.sync="costPage"
            >
              <template v-slot:top>
                <v-toolbar class="elevation-0 rounded-lg">
                  <v-spacer></v-spacer>
                  <v-col md="4">
                    <v-text-field
                      label="Buscar..."
                      class="mt-0"
                      v-model="searchCost"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-menu bottom origin="center center" transition="scale-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="mr-2 mt-n2" color="success" dark outlined v-bind="attrs" v-on="on">
                        <v-icon class="ml-2">mdi-download</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="save_cost_csv()">
                        <v-list-item-icon>
                          <v-icon color="success">mdi-file-excel-box</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Costos detallados excel</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-toolbar>
              </template>
              <template v-slot:[`item.costo_unitario`]="{ item }">
                {{ currencyFormat(item.costo_unitario) }} {{ item.moneda }}
              </template>
              <template v-slot:[`item.costo_total`]="{ item }">
                {{ currencyFormat(item.costo_total) }} {{ item.moneda }}
              </template>
              <template v-slot:[`item.precio`]="{ item }">
                {{ currencyFormat(item.precio) }} {{ item.moneda }}
              </template>
              <template v-slot:[`item.fecha_emision`]="{ item }">
                {{ item.fecha_emision ? item.fecha_emision.toString().substring(0, 10) : "" }}
              </template>
              <template v-slot:no-data>
                <v-row justify="center" class="pt-10">
                  <v-icon size="80px">token</v-icon>
                </v-row>
                <v-row justify="center" class="pb-6">No hay datos</v-row>
              </template>
              <template slot="footer">
                <v-row justify="center">
                  <v-container style="width: 70%" class="mt-4">
                    <v-pagination v-model="costPage" :length="costPageCount"></v-pagination>
                  </v-container>
                </v-row>
              </template>
            </v-data-table>
          </v-expand-transition>
          <v-divider></v-divider>
          <v-row align="center" class="pa-2 px-4">
            <v-col cols="12">
              <v-row dense>
                <v-col
                  v-for="group in totalCostByCurrency.byCurrency"
                  :key="group.moneda"
                  cols="12" sm="6" md="4" lg="3"
                >
                  <v-card outlined class="pa-2">
                    <div class="caption grey--text text--darken-1">{{ group.moneda }}</div>
                    <div class="d-flex justify-space-between mt-1">
                      <span class="caption">Costo:</span>
                      <span class="font-weight-bold success--text caption">{{ currencyFormat(group.costo_total) }}</span>
                    </div>
                    <div class="d-flex justify-space-between">
                      <span class="caption">Precio:</span>
                      <span class="font-weight-bold primary--text caption">{{ currencyFormat(group.precio) }}</span>
                    </div>
                    <template v-if="group.moneda !== 'USD'">
                      <v-divider class="my-1"></v-divider>
                      <div class="d-flex justify-space-between">
                        <span class="caption grey--text">Costo USD:</span>
                        <span class="caption grey--text text--darken-2">{{ currencyFormat(group.baseCosto) }}</span>
                      </div>
                      <div class="d-flex justify-space-between">
                        <span class="caption grey--text">Precio USD:</span>
                        <span class="caption grey--text text--darken-2">{{ currencyFormat(group.basePrecio) }}</span>
                      </div>
                    </template>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-card outlined class="pa-2" color="grey lighten-4">
                    <div class="caption grey--text text--darken-1">TOTAL BASE (USD)</div>
                    <div class="d-flex justify-space-between mt-1">
                      <span class="caption">Costo:</span>
                      <span class="font-weight-bold success--text caption">{{ currencyFormat(totalCostByCurrency.baseCosto) }}</span>
                    </div>
                    <div class="d-flex justify-space-between">
                      <span class="caption">Precio:</span>
                      <span class="font-weight-bold primary--text caption">{{ currencyFormat(totalCostByCurrency.basePrecio) }}</span>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import HeaderFilters from "@/components/Inventory/HeaderFilters.vue";
export default {
  data: () => ({
    activeTab: 0,
    page: 1,
    pageCount: 0,
    search: "",
    loading: false,
    costPage: 1,
    costPageCount: 0,
    searchCost: "",
    loadingCost: false,
    costDataLoaded: false,
    invoice_type: 0,
    invoice_category: 0,
    item_category_filter: 0,
    item_categories: [
      { value: 0, text: "Todo" },
      { value: 1, text: "Contado/efectivo" },
      { value: 2, text: "Credito" },
    ],
    currency_filter: 0,
    currencies: [
      { value: 0, text: "Todas" },
      { value: 1, text: "DOP" },
      { value: 2, text: "HTG" },
      { value: 3, text: "USD" },
    ],
    categories: [],
    items: [],
    costItems: [],
    headers: [
      { text: "ID", align: "start", value: "item_id" },
      { text: "Item", value: "item_name" },
      { text: "Categoria", value: "category_name" },
      { text: "Cantidad", value: "quantity" },
      { text: "Precio compra", value: "cost_amount", align: "end" },
      { text: "Precio venta", value: "sale_amount", align: "end" },
    ],
    costHeaders: [
      { text: "Sucursal", value: "location", width: "140px" },
      { text: "Tipo factura", value: "tipo_factura", width: "130px" },
      { text: "# Factura", value: "numero_factura", width: "120px" },
      { text: "Moneda", value: "moneda", width: "90px" },
      { text: "Fecha emisión", value: "fecha_emision", width: "130px" },
      { text: "Entidad", value: "entidad", width: "180px" },
      { text: "ID Art.", value: "item_id", width: "80px" },
      { text: "Artículo", value: "item", width: "200px" },
      { text: "Tipo artículo", value: "tipo_item", width: "130px" },
      { text: "Cantidad", value: "cantidad", align: "end", width: "90px" },
      { text: "Costo unitario", value: "costo_unitario", align: "end", width: "140px" },
      { text: "Costo total", value: "costo_total", align: "end", width: "130px" },
      { text: "Precio", value: "precio", align: "end", width: "120px" },
      { text: "Impuestos", value: "impuestos", align: "end", width: "110px" },
      { text: "Descuento", value: "descuento", align: "end", width: "110px" },
      { text: "Inventariable", value: "inventariable", width: "120px" },
      { text: "Almacén", value: "almacen", width: "130px" },
    ],
    lastFilters: {},
  }),
  components: {
    HeaderFilters,
  },
  computed: {
    totalValues() {
      return this.items.reduce(
        (totals, item) => {
          totals.neto += parseFloat(item.neto || 0);
          totals.cost += parseFloat(item.cost || 0);
          return totals;
        },
        { neto: 0, cost: 0 }
      );
    },
    totalCostByCurrency() {
      const groups = {};
      let baseCosto = 0;
      let basePrecio = 0;
      for (const item of this.costItems) {
        const moneda = item.moneda || "N/A";
        if (!groups[moneda]) groups[moneda] = { costo_total: 0, precio: 0, baseCosto: 0, basePrecio: 0 };
        const costo = parseFloat(item.costo_total || 0);
        const precio = parseFloat(item.precio || 0);
        const tasa = parseFloat(item.tasa_a || 1);
        groups[moneda].costo_total += costo;
        groups[moneda].precio += precio;
        groups[moneda].baseCosto += costo * tasa;
        groups[moneda].basePrecio += precio * tasa;
        baseCosto += costo * tasa;
        basePrecio += precio * tasa;
      }
      return {
        byCurrency: Object.entries(groups).map(([moneda, v]) => ({ moneda, ...v })),
        baseCosto,
        basePrecio,
      };
    },
  },
  methods: {
    buildFilters(data) {
      let filters = this.invoice_type !== 0
        ? `AND INVOICES.INVOICE_TYPE_ID = ${this.invoice_type}`
        : `AND INVOICES.INVOICE_TYPE_ID IN (2,3,5,8)`;
      if (data.business) {
        filters += ` AND BUSINESS_UNITS.ID IN (${data.business})`;
      }
      if (data.location && data.location.value && data.location.value !== 0) {
        filters += ` AND INVOICES.LOCATION_ID IN (${data.location.value})`;
      }
      if (data.warehouse && data.warehouse.id !== 0) {
        filters += ` AND INVOICE_DETAILS.WAREHOUSE_ID = ${data.warehouse.id}`;
      }
      if (this.invoice_category !== 0) {
        filters += ` AND INVOICES.INVOICE_CATEGORY_ID = ${this.invoice_category}`;
      }
      if (this.currency_filter !== 0) {
        filters += ` AND INVOICES.CURRENCY_ID = ${this.currency_filter}`;
      }
      if (this.item_category_filter !== 0) {
        filters += ` AND ITEMS.ITEM_CATEGORY_ID = ${this.item_category_filter}`;
      }
      filters += ` AND EMISSION_DATE::DATE BETWEEN '${data.dateStart}' AND '${data.dateEnd}'`;
      return filters;
    },
    async getData(data) {
      if (!data || !data.dateStart) return;
      this.lastFilters = data;
      this.costDataLoaded = false;
      this.loading = true;
      const filters = this.buildFilters(data);
      let resultInvoices = await this.api_Post("income/products_sales_list", {
        filters,
        currency_id: this.currency_filter,
      });
      this.items = await resultInvoices.json();
      const currencyLabel =
        this.currency_filter == 0
          ? "USD"
          : this.currencies.find((e) => e.value == this.currency_filter).text;
      for (let key in this.items) {
        this.items[key].sale_amount = `${this.currencyFormat(this.items[key].neto)} ${currencyLabel}`;
        this.items[key].cost_amount = `${this.currencyFormat(this.items[key].cost)} ${currencyLabel}`;
      }
      this.loading = false;
      if (this.activeTab === 1) {
        this.getCostData(data);
      }
    },
    async getCostData(data) {
      if (!data || !data.dateStart) return;
      this.loadingCost = true;
      const filters = this.buildFilters(data);
      const result = await this.api_Post("income/products_sales_cost_detail", { filters });
      const rows = await result.json();
      this.costItems = rows.map((r) => ({
        location: r.location,
        tipo_factura: r.tipo_factura,
        numero_factura: r.numero_factura,
        moneda: r.moneda,
        tasa_a: r.tasa_a,
        fecha_creacion: r.fecha_creacion,
        fecha_emision: r.fecha_emision,
        fecha_contable: r.fecha_contable,
        entidad: r.entidad,
        item_id: r.item_id,
        item: r.item,
        tipo_item: r.tipo_item,
        cantidad: r.cantidad,
        costo_unitario: r.costo_unitario,
        costo_total: r.costo_total,
        precio: r.precio,
        impuestos: r.impuestos,
        descuento: r.descuento,
        inventariable: r.inventariable,
        id_almacen: r.id_almacen,
        almacen: r.almacen,
      }));
      this.loadingCost = false;
      this.costDataLoaded = true;
    },
    onTabChange(tab) {
      if (tab === 1 && !this.costDataLoaded) {
        this.getCostData(this.lastFilters);
      }
    },
    changeBusiness(data) {
      if (data.business == 0) {
        this.getData({
          business: this.$store.state.auth.user.acess_business_unit_finance,
          location: null,
          warehouse: data.warehouse || { id: 0 },
          dateStart: data.dateStart,
          dateEnd: data.dateEnd,
        });
      } else {
        this.getData(data);
      }
      if (data.location && data.location.value) {
        this.get_item_categories(data.location.value);
      }
    },
    async get_item_categories(location_id) {
      const categories = await this.api_Get("inventory/categoryLocation/" + location_id);
      this.categories = await categories.json();
      this.categories.unshift({ id: 0, name: "TODO" });
    },
    save_csv() {
      let csv = "ID ARTICULO,CATEGORIA,DESCRIPCION,CANTIDAD,COSTO,MONTO";
      this.items.forEach((item) => {
        csv += `\n${item.item_id},${this.deleteDiacriticos(item.category_name)},${this.deleteDiacriticos(item.item_name)},${item.quantity},${item.cost},${item.neto}`;
      });
      this.generateCsvFile(
        `Reporte detallado de venta de articulos en ${
          this.lastFilters.warehouse && this.lastFilters.warehouse.id > 0
            ? this.lastFilters.warehouse.name
            : this.lastFilters.location
            ? this.lastFilters.location.text
            : "todos"
        } entre ${this.lastFilters.dateStart} y ${this.lastFilters.dateEnd}`,
        csv
      );
    },
    save_cost_csv() {
      let csv =
        "SUCURSAL,TIPO_FACTURA,NUMERO_FACTURA,MONEDA,TASA_A,TASA_B,FECHA_EMISION,FECHA_CREACION,FECHA_CONTABLE,ENTIDAD,ID_ARTICULO,ARTICULO,TIPO_ARTICULO,CANTIDAD,COSTO_UNITARIO,COSTO_UNITARIO_BASE,COSTO_TOTAL,COSTO_TOTAL_BASE,PRECIO,PRECIO_BASE,VENTA,VENTA_BASE,IMPUESTOS,DESCUENTO,INVENTARIABLE,ID_ALMACEN,ALMACEN";
      this.costItems.forEach((item) => {
        const fechaEmision = item.fecha_emision ? item.fecha_emision.toString().substring(0, 10) : "";
        const fechaCreacion = item.fecha_creacion ? item.fecha_creacion.toString().substring(0, 10) : "";
        const fechaContable = item.fecha_contable ? item.fecha_contable.toString().substring(0, 10) : "";
        const tasa = parseFloat(item.tasa_a || 1);
        const cantidad = parseFloat(item.cantidad || 0);
        const costoUnitario = parseFloat(item.costo_unitario || 0);
        const costoTotal = parseFloat(item.costo_total || 0);
        const precio = parseFloat(item.precio || 0);
        const costoUnitarioBase = (costoUnitario * tasa).toFixed(4);
        const costoTotalBase = (costoTotal * tasa).toFixed(4);
        const precioBase = (precio * tasa).toFixed(4);
        const venta = (precio * cantidad).toFixed(4);
        const ventaBase = (precio * tasa * cantidad).toFixed(4);
        csv += `\n${item.location},${item.tipo_factura},${item.numero_factura},${item.moneda},${item.tasa_a},${item.tasa_b},${fechaEmision},${fechaCreacion},${fechaContable},${item.entidad},${item.item_id},${item.item},${item.tipo_item},${cantidad},${costoUnitario},${costoUnitarioBase},${costoTotal},${costoTotalBase},${precio},${precioBase},${venta},${ventaBase},${item.impuestos},${item.descuento},${item.inventariable},${item.id_almacen},${item.almacen || ""}`;
      });
      this.generateCsvFile(
        `Costos detallados de venta en ${
          this.lastFilters.warehouse && this.lastFilters.warehouse.id > 0
            ? this.lastFilters.warehouse.name
            : this.lastFilters.location
            ? this.lastFilters.location.text
            : "todos"
        } entre ${this.lastFilters.dateStart} y ${this.lastFilters.dateEnd}`,
        csv
      );
    },
  },
};
</script>

<style></style>
